import { Component, OnInit, ViewChild, AfterContentInit, AfterViewInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '../../../../../node_modules/@angular/router';
import { UserDetailsRest } from './user-details.rest';
import { MessageBoxComponent } from '../../../core/shared/message-box.component';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { UserDetailsHeaderComponent } from './header/user-details-header.component';
import { LoginRest } from '../../../login/login.rest';
import { MatTabChangeEvent } from '@angular/material';
import { ProfilePictureService } from '../../../profile-picture/profile-picture.service';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';
import { MenuButton } from '../../../core/shared/tabmenu/tabmenu.model';
import { SpinnerService } from '../../../core/services/spinner-handler/spinner-handler.service';
import { GridParamsRestoringService } from '../../../core/services/grid-params-restoring/grid-params-restoring.service';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})

export class UserDetailsComponent implements OnInit, HasPermissions, AfterViewInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private rest: UserDetailsRest,
    private loginRest: LoginRest,
    private profilePictureService: ProfilePictureService,
    private permissionService: PermissionsService,
    private spinnerService: SpinnerService,
    private gridParamsRestoringService: GridParamsRestoringService
  ) { }

  permissions: Permissions;
  private userName: string;
  private picture: string;
  private messageBoxSubscription: Subscription;
  private userDetailsModel: any = { 'name': '' };
  private isNew = false;
  private isSaving = false;

  @ViewChild(MessageBoxComponent) messageBox: MessageBoxComponent;
  @ViewChild(UserDetailsHeaderComponent) userDetailsHeaderComponent: UserDetailsHeaderComponent;

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.saveUser();
    event.preventDefault();
  }

  private menuButtons: MenuButton[] = [
    { text: 'USER_deactivateButton', class: 'btn-warning', icon: '', onClick: () => { this.deactivate(); }, enabled: false, isForSelected: false },
    { text: 'USER_activateButton', class: 'btn-success', icon: '', onClick: () => { this.activate(); }, enabled: false, isForSelected: false },
    { text: 'USER_resetPasswordButton', class: 'btn-primary', icon: '', onClick: () => { this.resetPassword(); }, enabled: false, isForSelected: false },
    { text: 'COMMONBUTTONS_save', class: 'btn-success', icon: '', onClick: () => { this.saveUser(); }, enabled: false, isForSelected: false },
    { text: 'COMMONBUTTONS_close', class: 'btn-danger', icon: '', onClick: () => { this.close(); }, enabled: true, isForSelected: false }
  ];
  private saveButton = { text: 'COMMONBUTTONS_save', class: "btn-success", icon: '', onClick: () => { this.saveUser(); }, enabled: false, isForSelected: false };

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  ngOnInit() {
    this.spinnerService.show();
    this.setPermissions("User");

    this.route.queryParams.subscribe(params => {
      if (params.userName && params.userName !== '') {
        this.isNew = false;
        this.userName = params.userName;
        this.spinnerService.show();
        this.rest.getUserDetails(this.userName).subscribe(value => {
          this.userDetailsModel = value;
          this.userDetailsHeaderComponent.setModel(this.userDetailsModel, this.isNew, this.messageBox);
          this.spinnerService.hide();
        });
      } else {
        this.spinnerService.show();
        this.isNew = true;
        this.userDetailsModel = {};
        this.userDetailsHeaderComponent.setModel(this.userDetailsModel, this.isNew, this.messageBox);
        this.picture = this.userDetailsModel.picture;
        this.spinnerService.hide();
      }
    });

    this.profilePictureService.currentProfilePicture.subscribe(picture => this.userDetailsModel.picture = picture);
    this.setMenuButtonsPermissions();
  }

  ngAfterViewInit() {
    this.spinnerService.hide();
  }

  private setMenuButtonsPermissions() {
    this.menuButtons.find(b => b.text === 'USER_deactivateButton').enabled = this.permissions.canEdit === true && this.isNew === false;
    this.menuButtons.find(b => b.text === 'USER_activateButton').enabled = this.permissions.canEdit === true && this.isNew === false;
    this.menuButtons.find(b => b.text === 'USER_resetPasswordButton').enabled = this.permissions.canEdit === true && this.isNew === false;
    this.menuButtons.find(b => b.text === 'COMMONBUTTONS_save').enabled =
      (this.isNew && this.permissions.canAdd === true)
      || (!this.isNew && this.permissions.canEdit === true);
    this.saveButton.enabled = (this.isNew && this.permissions.canAdd === true)
      || (!this.isNew && this.permissions.canEdit === true);;
  }

  public tabChanged(tabChangeEvent: MatTabChangeEvent): void { }

  private deactivate() {
    const action = this.rest.deleteUser;

    action.call(this.rest, this.userName).subscribe(() => {
      sweetAlert({ text: 'Użytkownik został zdeaktywowany.' });
    });
  }

  private activate() {
    const action = this.rest.activateUser;

    action.call(this.rest, this.userName).subscribe(() => {
      sweetAlert({ text: 'Użytkownik został aktywowany.' });
    });
  }

  private resetPassword() {
    sweetAlert('Wymusić zmianę hasła użytkownika przy następnym logowaniu?', {
      buttons: {
        yes: {
          text: 'Tak',
          value: 'yes'
        },
        no: {
          text: 'Nie',
          value: 'no',
        }
      }
    })
      .then((value) => {
        switch (value) {
          case 'yes':
            this.rest.markPasswordChange(this.userName).subscribe(() => {
              sweetAlert('Hasło zostanie zresetowane przy następnym logowaniu.')
            });
            break;
        }
      });
  }

  private close() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }

  public saveUser() {
    if (!this.userDetailsHeaderComponent.isValid()) {
      sweetAlert('Należy wypełnić wszystkie wymagane pola');
      return;
    }

    if (this.isSaving) {
      return;
    }
    this.isSaving = true;
    const action = this.isNew ? this.rest.addUser : this.rest.editUser;
    action.call(this.rest, this.userDetailsHeaderComponent.user).subscribe(webUser => {
      if (this.isNew) {
        this.gridParamsRestoringService.saveAddingNewRowInfo(webUser.id);
      }
      this.isSaving = false;
      this.router.navigate(['../../'], { relativeTo: this.route });
    });
  }

  public onMessageBoxClose() {

  }
  private updateProfilePicture(picture: string) {
    this.profilePictureService.changePicture(picture);
  }

  private editUserPicture() {
    const action = this.rest.editUserPicture;
    let data = {
      userName: this.userDetailsModel.name,
      picture: this.picture
    };
    action.call(this.rest, data).subscribe(() => {
      this.updateProfilePicture(this.userDetailsModel.picture);
    });
  }

}
